import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiGetIngredientInfoSearch, apiGetUserCart } from "Root/api/apiCheckout";
import { setGlobalLoading } from "Root/profile/redux/actionCreators/makeActionCreator";
const initState = {
    userCart: [],
    ingredients: [],
    blendChanged: false,
};
export const fetchIngredients = createAsyncThunk("checkoutUserCart/fetchIngredients", async (fetchAll, { dispatch, getState }) => {
    const { checkoutUserCart } = getState();
    const keys = checkoutUserCart.userCart.map((item) => item.item_type).join(",");
    const data = await apiGetIngredientInfoSearch(keys, !!fetchAll);
    return data;
});
export const fetchCheckoutUserCart = createAsyncThunk("checkoutUserCart/fetchCheckoutUserCart", async (_, { dispatch }) => {
    dispatch(setGlobalLoading(true));
    const data = await apiGetUserCart();
    dispatch(setGlobalLoading(false));
    return data;
});
const checkoutUserCartSlice = createSlice({
    name: "checkoutUserCart",
    initialState: initState,
    reducers: {
        updateUserCart(state, action) {
            state.userCart = action.payload;
            return state;
        },
        setBlendChanged(state, action) {
            state.blendChanged = action.payload;
            return state;
        },
    },
    extraReducers(builder) {
        builder.addCase(fetchIngredients.fulfilled, (state, action) => {
            state.ingredients = action.payload;
            return state;
        });
        builder.addCase(fetchCheckoutUserCart.fulfilled, (state, action) => {
            state.userCart = action.payload;
        });
    },
});
export const { updateUserCart, setBlendChanged } = checkoutUserCartSlice.actions;
export default checkoutUserCartSlice.reducer;
